module.exports = __webpack_public_path__ + "files/6e7b084799798c795be70542b028a8bc.svg";